export default __webpack_public_path__ + "static/media/battery-three-qt-solid.dbfdb6e7.svg";